import { createReducer, on } from '@ngrx/store';
import { loginSuccess, loadLogin } from '../actions/login.actions';
import { loginState } from '../interfaces/loginState.interface';

export const initialState: loginState = { loading: false, sesionUsuario: {} };

export const loginReducer = createReducer(
  initialState,
  on(loadLogin, (state) => {
    return { ...state, loading: true };
  }),
  on(loginSuccess, (state, { sesionUsuario }) => {
    return { ...state, loading: false, sesionUsuario };
  })
);
